import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { installMutationFetch, onStaleWrite } from "@wedding/shared";
import { StaleWriteNotice } from "@wedding/ui";
import { App } from "./App";
import "./i18n";
import "./globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 300_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Tüm /api/* istekleri ortak değişiklik katmanından geçer (Idempotency-Key, çift gönderim birleştirme,
// belge sürümü If-Match) — ayrıntı: packages/shared/src/mutation-fetch.ts
installMutationFetch();
// Kayıt başka yerden değiştiği için reddedildi → ekrandaki tüm veri tazelenir.
onStaleWrite(() => void queryClient.invalidateQueries());

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <StaleWriteNotice />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
